import * as React from 'react';
import { useContext, useEffect } from 'react';
import {
  FaUsers,
  FaReceipt,
  FaBox,
  FaStoreAlt,
  FaCalendar,
  FaSearch,
} from 'react-icons/fa';
import i18n from '@/utils/i18n';
import { Link, useHistory } from 'react-router-dom';
import {
  IsEventAccountUser,
  IsEventOwnerClaim,
  ViewerContext,
} from '../providers/ViewerContextProvider';
import { Routes } from '@/utils/routes';
import { Role } from '../contants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export const Home = () => {
  const context = useContext(ViewerContext);
  const history = useHistory();

  useDocumentTitle('PageTitles:home');

  useEffect(() => {
    if (context.role === Role.terminalUser) {
      history.push(Routes.partnerMerchants());
    }

    if (
      IsEventAccountUser(context) &&
      context.eventIds &&
      context.eventIds.length > 0
    ) {
      history.push(Routes.eventsDashboardHome(context.eventIds[0]));
    }

    if (IsEventOwnerClaim(context)) {
      history.push(Routes.eventOwnerDashboard());
    }
  }, [context, history]);

  return (
    <div
      style={{
        maxWidth: 800,
        margin: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
      }}
    >
      <Link className="vytal-home-box" to={Routes.users()}>
        <FaUsers />
        <p>{i18n.t('Users:users')}</p>
      </Link>
      <Link className="vytal-home-box" to={Routes.partner()}>
        <FaStoreAlt />
        <p>{i18n.t('Common:partner')}</p>
      </Link>
      <Link className="vytal-home-box" to={Routes.events()}>
        <FaCalendar />
        <p>{i18n.t('Navigation:events')}</p>
      </Link>
      <Link className="vytal-home-box" to={Routes.containers()}>
        <FaBox />
        <p>{i18n.t('Users:containers')}</p>
      </Link>
      <Link className="vytal-home-box" to={Routes.billing()}>
        <FaReceipt />
        <p>{i18n.t('Common:billing')}</p>
      </Link>
      <Link className="vytal-home-box" to={Routes.orderFulfillmentSearch()}>
        <FaSearch />
        <p>{i18n.t('Event:orderFulfillments')}</p>
      </Link>
    </div>
  );
};
